import React from "react";
import {
  Box,
  Typography,
  Button,
} from "@mui/material";
import { IAcabamento } from "../types/acabamento.types";

interface TexturaCardProps {
  acabamento: Partial<IAcabamento>;
  onOpenModal: () => void;
}

export const TexturaCard: React.FC<TexturaCardProps> = ({
  acabamento,
  onOpenModal,
}) => {
  const temFigura = !!acabamento.texturaFiguraUrl;
  const temCor = !!acabamento.texturaCorHex || !!acabamento.texturaCorRgb;

  // FASE 05 — 5ª validação/Frente 1 2026-07-30: a figura PNG sempre sobrepõe a cor
  // hexadecimal (regra do relatório de 30/07).
  const exibirFigura = temFigura;
  const exibirCor = temCor && !exibirFigura;

  // FASE 05 — 6ª validação/PO 2026-08-13: quadro de Cor/Textura no MESMO padrão do quadro
  // "Imagem do produto" dos demais cadastros N1 (borda cinza, título em body2, área central
  // de 180px) e botão de gerenciamento FORA do quadro, logo abaixo.
  return (
    <>
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          backgroundColor: "#fff",
          p: 2,
          mb: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: "#333", mb: 2, fontWeight: 500 }}
        >
          Cor / Textura
        </Typography>

        {/* Miniatura */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 180,
            backgroundColor: "#fff",
            overflow: "hidden",
          }}
        >
          {exibirFigura && acabamento.texturaFiguraUrl ? (
            <Box
              component="img"
              src={acabamento.texturaFiguraUrl}
              alt="Textura"
              sx={{
                maxWidth: "100%",
                maxHeight: 180,
                objectFit: "contain",
              }}
            />
          ) : exibirCor && acabamento.texturaCorHex ? (
            <Box
              sx={{
                width: "100%",
                minHeight: 180,
                backgroundColor: acabamento.texturaCorHex,
                opacity: acabamento.texturaOpacidade
                  ? acabamento.texturaOpacidade / 100
                  : 1,
              }}
            />
          ) : (
            <Typography variant="body2" color="text.secondary">
              Nenhuma textura
            </Typography>
          )}
        </Box>

        {/* Nome do arquivo (se houver figura) */}
        {temFigura && acabamento.texturaFiguraNome && (
          <Typography
            variant="caption"
            sx={{ color: "#999", textAlign: "center", display: "block", mt: 2 }}
          >
            {acabamento.texturaFiguraNome}
          </Typography>
        )}
      </Box>

      {/* Botão FORA do quadro da textura */}
      <Button
        variant="contained"
        fullWidth
        onClick={onOpenModal}
        sx={{
          backgroundColor: "#3C90AD",
          "&:hover": { backgroundColor: "#2d6f87" },
          textTransform: "none",
          py: 1.2,
        }}
      >
        GERENCIAR COR / TEXTURA
      </Button>
    </>
  );
};
